export default function Services() {
  const services = [
    {
      icon: 'ri-palette-line',
      title: 'Logotipos Profesionales',
      description: 'Diseños únicos que representan la esencia de tu marca con creatividad y profesionalismo',
      color: 'from-[#ff00ff] to-[#ff00aa]'
    },
    {
      icon: 'ri-image-line',
      title: 'Banners Publicitarios',
      description: 'Banners impactantes para campañas digitales y físicas que capturan la atención',
      color: 'from-[#00ffff] to-[#0099ff]'
    },
    {
      icon: 'ri-file-paper-2-line',
      title: 'Flyers y Material Promocional',
      description: 'Diseños impresos que comunican tu mensaje de forma clara y atractiva',
      color: 'from-[#ff00aa] to-[#ff0066]'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Diseños para Redes Sociales',
      description: 'Contenido visual optimizado para Instagram, Facebook, TikTok y más plataformas',
      color: 'from-[#00ffff] to-[#00ff99]'
    },
    {
      icon: 'ri-brush-line',
      title: 'Identidad Visual',
      description: 'Creamos la imagen completa de tu marca con coherencia y estilo profesional',
      color: 'from-[#ff00ff] to-[#9900ff]'
    },
    {
      icon: 'ri-star-line',
      title: 'Branding Completo',
      description: 'Desarrollo integral de marca: desde el concepto hasta la implementación final',
      color: 'from-[#ff00aa] to-[#00ffff]'
    }
  ];

  return (
    <section id="servicios" className="py-24 bg-gradient-to-b from-[#0f0520] via-[#1a0b2e] to-[#2d1b4e] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-[#ff00ff] rounded-full mix-blend-screen filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-[#00ffff] rounded-full mix-blend-screen filter blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-gradient-to-r from-[#ff00ff]/20 to-[#00ffff]/20 backdrop-blur-sm border border-[#00ffff]/30 px-5 py-2 rounded-full mb-6">
            <span className="text-xs font-bold text-[#00ffff] uppercase tracking-wide">
              Nuestros Servicios
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Soluciones creativas para tu marca
          </h2>
          <p className="text-xl text-[#c0c0ff]">
            Transformamos ideas en diseños profesionales que impulsan tu negocio
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-[#1a0b2e]/80 to-[#2d1b4e]/80 backdrop-blur-sm border border-[#00ffff]/20 rounded-2xl p-8 hover:border-[#ff00ff]/50 transition-all duration-300 cursor-pointer hover:shadow-2xl hover:shadow-[#ff00ff]/30 hover:scale-105"
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${service.color} mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-[#c0c0ff] leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="https://wa.me/527131055034"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-[#ff00ff] to-[#00ffff] text-white px-12 py-5 rounded-full font-bold text-lg hover:scale-105 transition-transform cursor-pointer whitespace-nowrap shadow-2xl shadow-[#ff00ff]/50"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            SOLICITA TU DISEÑO HOY
          </a>
        </div>
      </div>
    </section>
  );
}
